require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./victim-offender-mediation.json") })
        }
      }, "path---victim-offender-mediation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---victim-offender-mediation!./.cache/json/victim-offender-mediation.json
// module id = 1063
// module chunks = 231608221292675